@for (sort of sortDefinitions; track sort) {
  <span
    class="group font-main font-bold text-sm text-navy-70"
    [ngClass]="{
      'cursor-pointer': isSortable(sort),
    }"
    [attr.data-test-id]="sort.id + '-sort-option'"
    (click)="selectHeaderSort(sort)"
  >
    @if (sort?.icon) {
      <svg-icon class="mr-1" [src]="sort.icon"></svg-icon>
    }

    <span class="group-hover:text-navy-90" [ngClass]="{ 'text-navy-90': isCaretShown(sort.id) }">
      {{ sort.translationKey | translate }}
    </span>

    @if (sort.infoTooltipTranslation) {
      <app-info-icon
        class="ml-1 relative top-0.5"
        [tooltipPosition]="'top'"
        [tooltipText]="sort.infoTooltipTranslation | translate"
      ></app-info-icon>
    }

    @if (isSortable(sort)) {
      <svg-icon
        data-test-id="sort-caret"
        class="m-1 transform group-hover:visible group-hover:pb-0.5"
        [ngClass]="{
          'rotate-180 pt-0.5': isCaretRotated(sort.id),
          'pb-0.5': !isCaretRotated(sort.id),
          invisible: !isCaretShown(sort.id),
          visible: isCaretShown(sort.id),
        }"
        [src]="'caret-down'"
        [stretch]="true"
      ></svg-icon>
    }
  </span>
}
